import { type ReactNode } from "react";
import { ThemeProvider } from "./theme";
import { NotificationProvider } from "./notification";
import { SearchProvider } from "./search";
import { ModalProvider } from "./modal";
import { TagInputProvider } from "./tag-input";
import { LayoutProvider } from "./layout";

export { ThemeProvider, useThemeContext, type ThemeContextValue } from "./theme";
export {
  NotificationProvider,
  useNotificationContext,
  type NotificationContextValue,
  type Notification,
} from "./notification";
export {
  SearchProvider,
  useSearchContext,
  type SearchContextValue,
} from "./search";
export {
  ModalProvider,
  useModalContext,
  type ModalContextValue,
  type ModalState,
} from "./modal";
export {
  TagInputProvider,
  useTagInputContext,
  type TagInputContextValue,
} from "./tag-input";
export {
  LayoutProvider,
  useLayoutContext,
  type LayoutContextValue,
  type DragState,
} from "./layout";

export function GuiProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <LayoutProvider>
        <NotificationProvider>
          <ModalProvider>
            <SearchProvider>
              <TagInputProvider>{children}</TagInputProvider>
            </SearchProvider>
          </ModalProvider>
        </NotificationProvider>
      </LayoutProvider>
    </ThemeProvider>
  );
}
